// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"rX-z","inlineTitle":"sX-z","sponsoredAdsWrapper":"tX-z","marketplaceRecosWrapper":"uX-z"};